import { render, staticRenderFns } from "./AcessoRestritoItem.vue?vue&type=template&id=39a21b2a&scoped=true&lang=pug"
import script from "./AcessoRestritoItem.vue?vue&type=script&lang=js"
export * from "./AcessoRestritoItem.vue?vue&type=script&lang=js"
import style0 from "./AcessoRestritoItem.styl?vue&type=style&index=0&id=39a21b2a&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a21b2a",
  null
  
)

export default component.exports